module.exports = __webpack_public_path__ + "d419f5da.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/banner/collect.jpg
// module id = 2748
// module chunks = 15